// for Landscape
const TABLET_WIDTH = 768
const TABLETLANDSCAPE_WIDTH = 1024
const DESKTOP_WIDTH = 1440
const LARGE_WIDTH = 1980

// breakpoint for swiper
export const breakpoints = {
  tablet: TABLET_WIDTH + 1,
  tabletLandscape: TABLETLANDSCAPE_WIDTH,
  desktop: DESKTOP_WIDTH + 1,
}

// screeens for tailwind
export const tailWindScreens = {
  tablet: '768px',
  tabletLandscape: '1024px',
  desktop: '1440px',
  large: '1980px',
}

// STRINGS

// PAGES
export const PDP_CONTAINER = '#pdp'
export const CHECKOUT_CONTAINER = '.checkout-page-wrapper'
export const PLP_VIEW_STORAGE_KEY = 'plpIsSingleCol'
export const BRAND_CHANEL_VIEW_STORAGE_KEY = 'brandChanelPlpIsSingleCol'

// VIRTUAL MIRROR
export const VIRTUAL_MIRROR_KEY = '090c2638-044d-4915-bcca-c4b8d0228184'

// SA FILTERS
let SA_HINGE_ID

export const setSAHingeFilterId = hingeId => {
  SA_HINGE_ID = hingeId
}

export const getSAHingeFilterId = () => {
  return SA_HINGE_ID && SA_HINGE_ID
}

// GOOGLE API KEY
export const GOOGLE_MAP_API_KEY = sessionStorage.getItem('googleMapApiKey')
// GOOGLE MAP URL
export const GOOGLE_MAP_URL = sessionStorage.getItem('googleMapUrl')
export const GOOGLE_GEOCODE_API_URL = sessionStorage.getItem('googlGeocodeApiUrl')
export const cmsColor = {
  'mine-shaft': '#222222',
  'emperor-grey': '#555555',
  'mercury-white': '#e6e6e6',
  'alabaster-white': '#f7f7f7',
  'blaze-orange': '#ff6c00',
  'pumpkin-orange': '#ff7714',
  'apricot-orange': '#ef8670',
  'tulip-tree-yellow': '#f2b140',
  'double-spanish-white': '#e8dbbd',
  'hippie-blue': '#539bb9',
  'razzmatazz-pink': '#d60b51',
  'buttercup-yellow': '#f6ae10',
  'paris-daisy-yellow': '#fff46e',
  'apricot-pink': '#ef8670',
  'ligth-gray': '#fcfcfc',
  'white-smoke': '#f5f5f5',
  white: '#ffffff',
}

// VIDEO EXTENSIONS
export const VIDEO_EXTENSIONS = ['.avi', '.mpe', '.mpeg', '.mp4', '.mpg', '.mov', '.mpv']

export const devicePixelRatio = window.devicePixelRatio

export const EUROPEAN_COUNTRIES = ['uk', 'es', 'de', 'nl', 'fr']

export const CONCTACT_US_PAGE_CLASS = 'get-support__body'
export const FORCED_FOCUS_CLASS = 'forced-focus'
export const KEYBOARD_NAVIGATION_CLASS = 'keyboard-navigation'
export const RXC_CONTEXT = 'sgh-rxc'
export const PRESCRIPTION_OBJECT_STORAGE_KEY = 'prescriptionObject'
export const RXC_OPEN_URL_PARAMS = 'open-rxc'
export const RXC_LENS_UPC_OBJECT_STORAGE_KEY = 'rxLensUpcObject'
export const COMING_SOON_FLAG = 'coming soon'


export const DEFAULT_PAGE_SIZE = 24
export const PRODUCTS_PER_ROW = 4

// Filter groups that expose an in-dropdown / in-accordion search input.
export const SEARCHABLE_FILTER_GROUPS = [
  'attributes_translated.BRAND',
  'attributes_translated.FRAME_SHAPE_FACET',
  'attributes_translated.LENS_TREATMENT_FACET',
]

export const attributesToRetrieveMainProducts = [
  'objectID',
  'x_groupkey',                       // Required for mapping variants
  'partnumberId',
  'catentryId',
  'categories',                     // Used as upc and mfpartnumber
  'attributes.BRAND',
  'attributes.MODEL_NAME',
  'attributes.FRAME_SHAPE',
  'attributes.FRAME_SIZE_DISPLAY',
  'attributes.MODEL_CODE_DISPLAY',
  'attributes.DISPLAYSKU',
  'attributes.SKU',
  'attributes.PRODUCT_TYPE',
  'attributes.LENS_TREATMENT',
  'attributes.LENS_CERTIFIED_TECHNOLOGY',
  'attributes.GENDER',
  'attributes.POLARIZED',
  'attributes.RX_FILTER',
  'attributes.CUSTOMER_TYPE',         // For loyalty
  'attributes.CUSTOMIZABLE',          // For remix
  'attributes.ENGRAVABLE',
  'attributes.LIFECYCLE',
  'attributes.INSTALLMENTS_PLP',
  'attributes.VTO_ENABLED',
  'attributes_translated.BADGE_CHANNEL',
  'attributes_translated.ELECTRONICS_TECHNOLOGY',
  'attributes_translated.FRONT_COLOR_FACET',
  'attributes_translated.LENS_COLOR_FACET',
  'attributes_translated.FRONT_COLOR',
  'attributes_translated.FRAME_MATERIAL_FACET',
  'attributes_translated.MODEL_NAME',
  'attributes_translated.CHANNEL_DETAILS',
  'attributes_translated.RUNWAY',
  'attributes_translated.LAUNCH_DATE_CODE',
  'attributes_translated.LIMITED_EDITION',
  'attributes_translated.AVANT_PREMIERE_DATE',
  'attributes_translated.SPECIAL_PROJECT_TYPE',
  'attributes_translated.CUSTOMER_TYPE',
  'prices',
  'badgeBelowLeft',
  'badgeBelowRight',
  'promo',
  'status',                           // Needed for Status
  'productId',                        // Used as catentryId
  'url',                              // For building pdpURL
  'remixableUrl',                     // For building customizeURL
  'colors',                           // Needed to render color variants
  'attachments',                      // On model image
  'isFindInStore',                    // Optional logic
  'isEmailMeWhenAvailable',
  'inventoryQuantity',
  'juniorLabel',
  'lifecycle',
  'roxableLabel',
  'sortBadge_EarlyAccess',
  'sortBadge_Guest',
  'sortDiscount_EarlyAccess',
  'sortDiscount_Guest',
  'sortPrice_EarlyAccess',
  'sortPrice_Guest'
]

export const attributesToRetrieveVariants = [
  'objectID',
  'x_groupkey',                       // Required for mapping variants
  'partnumberId',
  'catentryId',
  'categories',                     // Used as upc and mfpartnumber
  'attributes.BRAND',
  'attributes.MODEL_NAME',
  'attributes.FRAME_SHAPE',
  'attributes.FRAME_SIZE_DISPLAY',
  'attributes.MODEL_CODE_DISPLAY',
  'attributes.DISPLAYSKU',
  'attributes.SKU',
  'attributes.PRODUCT_TYPE',
  'attributes.LENS_TREATMENT',
  'attributes.LENS_CERTIFIED_TECHNOLOGY',
  'attributes.GENDER',
  'attributes.POLARIZED',
  'attributes.RX_FILTER',
  'attributes.CUSTOMER_TYPE',         // For loyalty
  'attributes.CUSTOMIZABLE',          // For remix
  'attributes.ENGRAVABLE',
  'attributes.LIFECYCLE',
  'attributes.INSTALLMENTS_PLP',
  'attributes.VTO_ENABLED',
  'attributes_translated.BADGE_CHANNEL',
  'attributes_translated.ELECTRONICS_TECHNOLOGY',
  'attributes_translated.FRONT_COLOR_FACET',
  'attributes_translated.LENS_COLOR_FACET',
  'attributes_translated.FRONT_COLOR',
  'attributes_translated.FRAME_MATERIAL_FACET',
  'attributes_translated.MODEL_NAME',
  'attributes_translated.CHANNEL_DETAILS',
  'attributes_translated.RUNWAY',
  'attributes_translated.LAUNCH_DATE_CODE',
  'attributes_translated.LIMITED_EDITION',
  'attributes_translated.AVANT_PREMIERE_DATE',
  'attributes_translated.SPECIAL_PROJECT_TYPE',
  'attributes_translated.CUSTOMER_TYPE',
  'prices',
  'badgeBelowLeft',
  'badgeBelowRight',
  'promo',
  'status',                           // Needed for Status
  'productId',                        // Used as catentryId
  'url',                              // For building pdpURL
  'remixableUrl',                     // For building customizeURL
  'colors',                           // Needed to render color variants
  'attachments',                      // On model image
  'isFindInStore',                    // Optional logic
  'isEmailMeWhenAvailable',
  'inventoryQuantity',
  'juniorLabel',
  'lifecycle',
  'roxableLabel',
  'sortBadge_EarlyAccess',
  'sortBadge_Guest',
  'sortDiscount_EarlyAccess',
  'sortDiscount_Guest',
  'sortPrice_EarlyAccess',
  'sortPrice_Guest'
]
export const SGH_CART_ITEMS_KEY ='SGH_CARTITEMS'
//LEGACY - STS

export const SHIPPING_METHOD_STORAGE_KEY = 'shippingMethod'
export const ORDER_SHIPPING_MODE_STORAGE_KEY = 'orderShippingMode'
//LEGACY - SFS
// key:zipForExpressShipping
export const STS_ADDRESS_STRING_STORAGE_KEY = 'zipForExpressShipping'
//key:choosenExpressShippingWindow
export const STS_SHIPPING_WINDOW_KEY = 'choosenExpressShippingWindow'
//key:choosenExpressShippingData
export const STS_SHIPPING_DATA_KEY = 'choosenExpressShippingData'
//key:delivLocalData
export const STS_DELIVERY_LOCAL_DATA_KEY = 'delivLocalData'

//LEGACY - CNC
//key:zipForCnCShipping
export const CNC_ADDRESS_STRING_STORAGE_KEY = 'zipForCnCShipping'
//key:choosenCNCShippingData
export const CNC_SHIPPING_DATA_KEY = 'choosenCNCShippingData'
export const CNC_STORES_API_DATA_KEY = 'storesInfo'


//STS - NEW CONSTANTS
//key:stsShippingWindowId
export const STS_SHIPPING_WINDOW_ID = 'stsShippingWindowId'
//LEGACY - CEP
//key:zipForShipping
export const CEP_ZIP_STORAGE_KEY = 'zipForShipping'
//key:dateForShipping
export const CEP_DATE_STORAGE_KEY = 'dateForShipping'
//key:slotForShipping
export const CEP_SLOT_STORAGE_KEY = 'slotForShipping'

//AUSTRALIA TOLL SHIPPING
export const TOLL_SHIPPING_ADDRESS_KEY = 'choosenANZExpressShippingAddress'
export const TOLL_DATA_ADDRESS_KEY = 'tollLocalData'
export const TOLL_DATA_FULL_ADDRESS_KEY = 'choosenANZExpressShippingInfo'
//CEP - NEW CONSTANTS
export const CEP_SHIPPING_OPTIONS = 'zipShippingOptions'
export const CEP_EXPIRE_COOKIE = `${CEP_DATE_STORAGE_KEY}_expire_date`

export const CNC_STORES_WEEK_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const SHIPPING_INFO_COUNTRY_CODE_KEY = 'shippingInfoCountryCode'
export const CNC_KEYS = [CNC_SHIPPING_DATA_KEY, CNC_ADDRESS_STRING_STORAGE_KEY, CNC_STORES_API_DATA_KEY]
export const STS_KEYS = [STS_ADDRESS_STRING_STORAGE_KEY, STS_SHIPPING_WINDOW_KEY, STS_SHIPPING_DATA_KEY,STS_DELIVERY_LOCAL_DATA_KEY,STS_SHIPPING_WINDOW_ID]
export const CEP_KEYS = [CEP_ZIP_STORAGE_KEY, CEP_DATE_STORAGE_KEY, CEP_SLOT_STORAGE_KEY, CEP_SHIPPING_OPTIONS]
export const TOLL_KEYS = [TOLL_SHIPPING_ADDRESS_KEY, TOLL_DATA_ADDRESS_KEY,TOLL_DATA_FULL_ADDRESS_KEY]
export const SHIPPING_METHODS_CODES = {
  CNC: 'CNC',
  STS: 'STS',
  CEP: 'CEP',
  TOLL: 'TOLL',
}

export const ShippingMethodsKeys= {
  CNC: CNC_KEYS,
  STS: STS_KEYS,
  CEP: CEP_KEYS,
  TOLL: TOLL_KEYS,
}

export const TOLL_EXPRESS_SHIPPING_TYPE = 'express_sd'
export const GRAVITY_SHIPPING_TYPE = 'gravity_exp'
export const STANDARD_SHIPPING_TYPE = 'standard'
export const PREMIUM_SHIPPING_TYPE = 'premium'
export const STS_SHIPPING_TYPE = 'express_sd'
export const EXPRESS_EXP_SHIPPING_TYPE = 'express_exp'
export const E_GIFT_SHIPPING_TYPE = 'egift'
export const STANDARD_MILITARY_SHIPPING_TYPE = 'standard_military'
export const EXPRESS_SUPER_SHIPPING_TYPE = 'express_super'
export const GREEN_SHIPPING_TYPE = 'green'
export const STANDARD_PO_SHIPPING_TYPE = 'standard_po'
export const COLLECT_IN_STORE_SHIPPING_TYPE = 'cnc'
export const HOME_SHIPPING_METHODS_TYPES = [
  STANDARD_MILITARY_SHIPPING_TYPE,
  STANDARD_SHIPPING_TYPE,
  PREMIUM_SHIPPING_TYPE,
  STS_SHIPPING_TYPE,
  EXPRESS_EXP_SHIPPING_TYPE,
  E_GIFT_SHIPPING_TYPE,
  EXPRESS_SUPER_SHIPPING_TYPE,
  GREEN_SHIPPING_TYPE,
  STANDARD_PO_SHIPPING_TYPE,
  TOLL_EXPRESS_SHIPPING_TYPE,
  GRAVITY_SHIPPING_TYPE
]
export const STORE_SHIPPING_METHODS_TYPES = [
  COLLECT_IN_STORE_SHIPPING_TYPE
]

export const shippingMethodsGroups = {
  home: HOME_SHIPPING_METHODS_TYPES,
  store: STORE_SHIPPING_METHODS_TYPES,
}
export const addressFinderErrorCodes = {
  CNC_ERROR_NOT_AVAILABLE: 'CNC_ERROR_NOT_AVAILABLE',
  _ERR_RTIC_NO_NEAR_BY_STORES: '_ERR_RTIC_NO_NEAR_BY_STORES',
  CNC_ERROR_GENERIC: 'CNC_ERROR_GENERIC',
  NO_LOCATION_DATA: 'NO_LOCATION_DATA',
  NO_STORES_BY_LOCATION: 'NO_STORES_BY_LOCATION',
  MISSING_PREDICTIONS: 'MISSING_PREDICTIONS',
  PRESELECTED_STORE_NOT_AVAILABLE: 'PRESELECTED_STORE_NOT_AVAILABLE',
  FIELD_EMPTY: 'FIELD_EMPTY',
  RTIC_ERROR_GEOLOCATION_FAILED: 'RTIC_ERROR_GEOLOCATION_FAILED',
  NO_PREDICTIONS_MATCHING_TYPES: 'NO_PREDICTIONS_MATCHING_TYPES',
  ERR_SHIPPING_ESTIMATION_GENERIC: 'ERR_SHIPPING_ESTIMATION_GENERIC',
  EXPRESS_ERROR_GENERIC: 'EXPRESS_ERROR_GENERIC',
  CART_CEP_ERROR_GENERIC: 'CART_CEP_ERROR_GENERIC',
}
export const PRODUCTS_NOT_ELIGIBLE_ERROR = 'NOT_ELIGIBLE_PRODUCTS'
export const omniChannelErrors = {
  NOT_ELIGIBLE_PRODUCTS:PRODUCTS_NOT_ELIGIBLE_ERROR,
  NOT_ELIGIBLE_PRODUCTS_SFS:'NOT_ELIGIBLE_PRODUCTS_SFS',
  NOT_ELIGIBLE_PRODUCTS_CNC:'NOT_ELIGIBLE_PRODUCTS_CNC',
  NOT_ELIGIBLE_PRODUCTS_STS:'NOT_ELIGIBLE_PRODUCTS_STS',
}
export const SHIPPING_METHODS_ADDRESS_FINDER_PREMISES = []
export const SHIPPING_OVERLAY_FLOW = 'shippingOverlayFlow'
export const CEP_SERVICE_URL = sessionStorage.getItem('cepServiceUrl')

export const UNGROUPED_PLP_CONF_KEY = 'ungroupedPlp'
export const UNGROUPED_PLP_CATEGORY_CONF_KEY ='ungroupedCategory'
export const FIS_AVAILABLE_STORES_FILTER_KEY = 'fisAvailableStoresFilterEnabled'
export const CART_ORDER_ITEMS_COUNT_CHANGED_EVENT = 'cart:order-items-count-changed'
export const CART_PROCEED_TO_CHECKOUT_BUTTON_CLICK = 'cart:proceed-to-checkout-button-clicked'
export const CART_SUN_LOVE_PROTECTION_CHANGED_EVENT = 'cart:sun-love-protection-changed'
export const CART_CEP_SELECTED_DATE_EXPIRED_EVENT = 'cart:cep-selected-data-expiry'
export const CART_ITEM_REMOVED_EVENT = 'cart:item-removed'
export const CART_ITEM_ADDED_EVENT = 'cart:item-added'
export const CART_REFRESH_EVENT = 'cart:ajax-refresh-event'
export const GIFT_WRAP_ADDED_EVENT = 'cart:gift-wrap-added-event'
export const GIFT_WRAP_REMOVED_EVENT = 'cart:gift-wrap-removed-event'
export const RELOAD_PAGE_EVENT = 'cart:reload-page-event'
export const CART_VIEW_REFRESH_REQUEST_EVENT = 'cart:ajax-view-refresh-request-event'
export const CART_PRESELECTED_STORES_FOUND = 'cart-preselected-stores-found'
export const IS_SEARCH_OPEN_CLASS = '--is-search-open'
export const COUNTRY_CART_STORAGE_KEY = 'sgh-cart-country'
export const CITY_TYPES = ['locality', 'administrative_area_level_1']

export const CHECKOUT_BUTTON_SELECTOR = `
  a[data-validate-cart-shipping],
  button[data-validate-cart-shipping],
  div[data-validate-cart-shipping]
`
export const CHECKOUT_SFS_VALIDATION_INPUT_ID = 'isAvaliableForSFS'
 export const LAZY_COMPONENTS_MAP  = {
  'sgh-shipping-methods': () => import( /*webpackChunkName:"sgh-shipping-methods"*/'@components/cart/shipping-methods.vue'),
   'sgh-gift-wrap': () =>
    import(/* webpackChunkName: "sgh-cart-gift-wrap" */ '@components/cart/gift-wrap/gift-wrap.vue'),
  'sgh-gift-wrap-product': () =>
    import(
      /* webpackChunkName: "sgh-cart-gift-wrap" */ '@components/cart/gift-wrap/gift-wrap-product.vue'
     ),
  'sgh-wishlist-cart': () =>
    import(
      /* webpackChunkName: "sgh-wishlist-cart" */ '@components/cart/wishlist/wishlist-cart.vue'
    ),
   'sgh-cart-loyalty-banner':() =>import(/* webpackChunkName: "sgh-cart-loyalty-banner" */ '@components/loyalty/loyalty-banner.vue'),
   'sgh-cart-recommended-carousel': () => import(/* webpackChunkName: "sgh-cart-recommended-carousel" */ '@components/cart/recommended-carousel.vue'),
   'sgh-select': () => import(/* webpackChunkName: "sgh-select" */ '@components/ui-components/select.vue'),
}

export const DEFAULT_PROVIDERS_LIST = ['afterpay', 'paypal', 'klarna']

export const NormalizedLocales = {
  'fr_CA': 'ca-fr',
  'en_CA': 'ca-en'
}

//WORDLIFT
export const WORDLIFT_MAIN_URL = sessionStorage.getItem('wordliftMainUrl')

//RTR
export const RTR_MV_SCRIPT_URL = sessionStorage.getItem('rtrMvScriptUrl')
export const RTR_INIT_KEY = sessionStorage.getItem('rtrInitKey')

export const CUSTOMER_CARE_PHONE = sessionStorage.getItem('customerCarePhone')
